"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _decorate = require("@/api/zdyPage/decorate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'videoStyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || ''
    };
  },
  computed: {
    // 宽高单位随背景图切换：有背景图按 %，无背景图按 px（0 表示自适应）
    widthUnitTip: function widthUnitTip() {
      return this.datas.bgSrc ? '%（相对视频原始宽度，100=默认大小）' : 'px（0 表示自适应）';
    },
    heightUnitTip: function heightUnitTip() {
      return this.datas.bgSrc ? '%（相对视频原始高度，100=默认大小）' : 'px（0 表示自适应）';
    }
  },
  methods: {
    handleVideoClick: function handleVideoClick() {
      var input = this.$refs.videoInput;
      if (input) input.click();
    },
    handleBgClick: function handleBgClick() {
      var input = this.$refs.bgInput;
      if (input) input.click();
    },
    handleVideoChange: function handleVideoChange(event) {
      var _this = this;
      var file = event.target.files[0];
      if (!file) return;
      var isVideo = file.type.startsWith('video/');
      var isLt50M = file.size / 1024 / 1024 < 50;
      if (!isVideo) {
        this.$message.error('上传文件只能是视频格式!');
        return;
      }
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 50MB!');
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        if (res.code === 200) {
          var videoSrc = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          _this.$set(_this.datas, 'videoSrc', videoSrc);
          _this.$message.success('上传成功');
        } else {
          _this.$message.error('上传失败：' + res.message);
        }
      }).catch(function (err) {
        _this.$message.error('上传失败：' + err);
        console.error(err);
      });

      // 清空 input 的 value，允许相同文件再次触发 change
      event.target.value = '';
    },
    handleBgChange: function handleBgChange(event) {
      var _this2 = this;
      var file = event.target.files[0];
      if (!file) return;
      var isImage = file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
        return;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        if (res.code === 200) {
          var bgSrc = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          _this2.$set(_this2.datas, 'bgSrc', bgSrc);
          _this2.$message.success('上传成功');
        } else {
          _this2.$message.error('上传失败：' + res.message);
        }
      }).catch(function (err) {
        _this2.$message.error('上传失败：' + err);
        console.error(err);
      });
      event.target.value = '';
    },
    clearVideo: function clearVideo() {
      this.$set(this.datas, 'videoSrc', '');
    },
    clearBg: function clearBg() {
      this.$set(this.datas, 'bgSrc', '');
    }
  }
};